import { Div, CollectionView, Span, TableBuilder, Link, Collection } from "@tblabs/truffle";
import { Calendar } from "../../../../../Components/Calendar/Calendar";
import { CalendarEntry } from "../../../../../Components/Calendar/CalendarEntry";
import { Order } from "../../../../../Models/Order";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { CashType } from "../../../../../Steps/Step/CashType";
import { TimeUtils } from "../../../../../Utils/TimeUtils";
import moment from "moment";
import { OrdersManager } from "../../../../../Services/Storage/OrdersManager";
import { OrdersFolders } from "../../../../../Models/OrdersFolders";
import { StringUtils } from "../../../../../Utils/StringUtils";


export class ProfitView extends Div
{
    constructor(private orders: CollectionView<Order>)
    {
        super();
        this.TextAlignCenter();

        const incomes = this.orders.Items.flatMap(order => order.Mana([CashType.ReceivedIncome]));
        // const total = incomes.reduce((acc, income) => acc + income.Amount, 0);
        const total = this.orders.Items.reduce((acc, order) => acc + order.Profit, 0);

        const incomesByDay = incomes.reduce((acc, income) =>
        {
            const dateKey = income.When.toDateString();
            if (!acc[dateKey])
            {
                acc[dateKey] = [];
            }
            acc[dateKey].push(income);
            return acc;
        }, {} as Record<string, typeof incomes>);


        const calendarEntries: CalendarEntry[] = Object.entries(incomesByDay).map(([date, incomes]) =>
            new CalendarEntry(new Date(date), () =>
            {
                let content: appendable[] = [];
                const dayTotal = incomes.reduce((acc, income) => acc + income.Amount, 0);

                if (dayTotal > 0)
                    content.push(new Span("+" + dayTotal + " zł").Class("uk-badge").FontSize(15));
                return content;
            }));

        const calendar = new Calendar(calendarEntries);

        this.Append(
            "Uwaga! To źle liczy! Do poprawki!",
            calendar,
            new Span(total + " zł").Class("uk-badge").FontSize(20)
        );
    }
}

export class ProfitViewV2 extends Div
{
    constructor(private _manager: OrdersManager)
    {
        super();
        this.TextAlignCenter();
    }

    async OnAppend()
    {
        const open: Order[] = await this._manager.FetchAll(OrdersFolders.Open);
        const closed: Order[] = await this._manager.FetchAll(OrdersFolders.Closed);

        const orders = new Collection(open.concat(closed).sort((a, b) => +b.Meta.CreatedAt - +a.Meta.CreatedAt));

        const assumedProfit = orders.Items.reduce((acc, order) => acc + order.BasketValue, 0);
        const totalProfit = orders.Items.reduce((acc, order) => acc + order.Profit, 0);

        const profitByDay: ({ Day: Date, Orders: Order[] })[] = [];

        orders.Items.filter(x => x.FinishedAt)
            .forEach((order) =>
            {
                const dateKey = moment(order.FinishedAt);

                const day = profitByDay.find(x => moment(x.Day).isSame(dateKey, "day"));

                if (day)
                    day.Orders.push(order);
                else
                    profitByDay.push({ Day: dateKey.toDate(), Orders: [order] });
            });

        const calendarEntries: CalendarEntry[] = profitByDay.map(x =>
            new CalendarEntry(
                x.Day,
                () => [
                    new Span(x.Orders.filter(x => x.FinishedAt).reduce((acc, order) => acc + order.Profit, 0) + " zł" + " ("+x.Orders.length+")").Class("uk-badge").FontSize(15),
                    // "\n",
                    // new Span(x.Orders.filter(x => !x.FinishedAt).reduce((acc, order) => acc + order.BasketValue, 0) + " zł").Class("uk-badge").FontSize(15).Background("gray"),
                ])
        );

        const profitByMonth: ({ Month: string, Orders: Order[] })[] = [];
        orders.Items.filter(x => x.FinishedAt).forEach(order =>
        {
            const m = moment(order.FinishedAt).format("YYYY-MM");
        
            const month = profitByMonth.find(x => moment(x.Month).format("YYYY-MM") === m);
            if (month)
                month.Orders.push(order);
            else
                profitByMonth.push({ Month: m, Orders: [order] });
        });

        this.Append(
            new TableBuilder(profitByMonth).TextAlignRight()
                .AddColumn("Miesiąc", x => moment(x.Month).format("MM.YYYY"))
                // .AddColumn("Orders", x => x.Orders.length + `: ${x.Orders.map(o => (o.IsDone ? "✅" : "🕐") + o.ShortId).join(", ")}`)
                .AddColumn("Orders", x => x.Orders.length)
                .AddColumn("Profit", x => {
                    const sum = x.Orders.reduce((acc, order) => acc + order.Profit, 0);
                    return StringUtils.FormatMoney(sum);
    })
                .Build()
                .Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(),

            new Calendar(calendarEntries),
            new TableBuilder(profitByDay.sort((a, b) => +b.Day - +a.Day)).TextAlignLeft()
                .AddColumn("Data", x => TimeUtils.FormattedDate(x.Day))
                .AddColumn("Orders", x => x.Orders.length + `: ${x.Orders.map(o => (o.IsDone ? "✅" : "🕐") + o.ShortId).join(", ")}`)
                .AddColumn("Profit", x =>
                {
                    const profit = x.Orders.reduce((acc, order) => acc + order.Profit, 0);
                    const basketValue = x.Orders.reduce((acc, order) => acc + order.BasketValue, 0);
                    return profit + " zł / " + basketValue + " zł";
                })
                .Build()
                .Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(),

            new TableBuilder(orders)
                .AddColumn("Zamówienie", x => new Link(x.ShortId, `#admin/order/view/${x.Id}`))
                .AddColumn("Status", (record, row) =>
                {
                    row.Background(record.IsDone ? "#e6ffe6" : "#e6f0fa");

                    return record.Status;
                })
                .AddColumn("Szacowany profit", x => x.BasketValue + " zł")
                .AddColumn("Profit", x => x.Profit + " zł")
                .AddColumn("Kiedy", x => TimeUtils.FormattedDate(x.Meta.CreatedAt))
                .Build()
                .Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(),

            "\n\n",
            new Span(totalProfit + " zł").Class("uk-badge").FontSize(20),
            " z ",
            new Span(assumedProfit + " zł").FontSize(20),
            "\n\n\n",
        );
    }
}
